import { render } from "./TabletFooter.vue?vue&type=template&id=00a575a2&scoped=true"
import script from "./TabletFooter.vue?vue&type=script&lang=js"
export * from "./TabletFooter.vue?vue&type=script&lang=js"

import "./TabletFooter.vue?vue&type=style&index=0&id=00a575a2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a575a2"]])

export default __exports__